import { render, staticRenderFns } from "./HomeContent.vue?vue&type=template&id=2c3aa931&scoped=true"
import script from "./HomeContent.vue?vue&type=script&lang=ts"
export * from "./HomeContent.vue?vue&type=script&lang=ts"
import style0 from "./HomeContent.vue?vue&type=style&index=0&id=2c3aa931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3aa931",
  null
  
)

export default component.exports